import styled from 'styled-components'

export const Image = styled.img`
    border-radius: 50%;
    
    :hover{
        background-color: #F6F9FC;
        opacity: 0.5;
    }
`